program klussenbeheer;

uses
  Vcl.Forms,
  WEBLib.Forms,
  Unit1 in 'Unit1.pas';

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm1, Form1);
  //Application.CreateForm(TForm1, Form1);
  Application.Run;
end.
